import { logUsage } from 'owa-analytics';
import getQuickComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getQuickComposeViewState';
import isOofSettingEnabled from './isOofSettingEnabled';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { isNullOrWhiteSpace } from 'owa-string-utils';
import {
    isSameDay,
    isSameTime,
    userDate,
    differenceInMinutes,
    differenceInCalendarDays,
    now,
} from 'owa-datetime';

export enum FormCloseType {
    Save = 'Save',
    Discard = 'Discard',
    OptionsPageFromMessageBar = 'OptionsPageFromMessageBar',
    OptionsPage = 'OptionsPage',
}

export default function logOofMetrics(formCloseType: FormCloseType) {
    const { originalEvent, event } = getComposeStore();
    const { oofViewState } = getQuickComposeViewState();
    if (!oofViewState.mailboxAutoReplyConfiguration) {
        return;
    }

    const config = oofViewState.mailboxAutoReplyConfiguration;
    const isOofEnabled: boolean = isOofSettingEnabled(config);
    const subjectSet: boolean =
        event.Subject != originalEvent.Subject && !isNullOrWhiteSpace(event.Subject);

    // log start & end date change
    const originalStart = isOofEnabled ? userDate(config.StartTime) : originalEvent.Start;
    const originalEnd = isOofEnabled ? userDate(config.EndTime) : originalEvent.End;

    const startDateSet = !isSameDay(originalStart, event.Start);
    const endDateSet = !isSameDay(originalEnd, event.End);
    const startTimeSet = !isSameTime(originalStart, event.Start);
    const endTimeSet = !isSameTime(originalEnd, event.End);

    const daysTillEvent = differenceInCalendarDays(event.Start, now());
    const eventDuration = differenceInMinutes(event.End, event.Start);

    // log status of checkboxes
    const {
        declineNewInvitationsEnabled,
        declineExistingCalendarEventsEnabled,
        autoReplyEnabled,
        autoReplyViewState,
    } = oofViewState;

    let datapoint = {
        isOofEnabled: isOofEnabled,
        subjectSet: subjectSet,
        startDateSet: startDateSet,
        startTimeSet: startTimeSet,
        endDateSet: endDateSet,
        endTimeSet: endTimeSet,
        daysTillEvent: daysTillEvent,
        duration: eventDuration,
        declineNewInvite: declineNewInvitationsEnabled,
        declineExistingEvents: declineExistingCalendarEventsEnabled,
        autoReplyEnabled: autoReplyEnabled,
        formCloseType: formCloseType,
    };

    if (autoReplyEnabled) {
        datapoint['hasAutoReplyMessage'] = !isNullOrWhiteSpace(autoReplyViewState.content);
        datapoint['autoReplyMessageChanged'] = autoReplyViewState.isDirty;
    }

    logUsage('QuickComposeOof', datapoint);
}
